import React from "react";
import { array, func, string, bool, object, number } from "prop-types";
import Feedback from "./Feedback";

const Collection = ({
    itemComponent,
    redirections,
    className,
    restUrl,
    itemClassName,
    isLoading,
    data,
    currentPage = 1,
    trackImpressions,
    trackClicks,
    actionField,
    showSeller,
    dfpMidAd,
    view
}) => {
    const Item = itemComponent;

    return (
        <div className={className}>
            {data.length > 0 ? (
                data.map((record, index) => {
                    const itemComponent = (
                        <Item
                            key={`collection-item-${index}`}
                            className={itemClassName}
                            restUrl={restUrl}
                            redirections={redirections}
                            trackImpressions={trackImpressions}
                            trackClicks={trackClicks}
                            actionField={actionField}
                            positionIndex={currentPage == 1 ? (index + 1) : (currentPage + (index + 1))}
                            show_seller={showSeller}
                            view={view}
                            {...record}
                        />
                    );

                    return index === Math.floor(data.length / 2) && dfpMidAd ? (
                        <div key={`collection-with-dfp-${index}`}>
                            <div id="mount-mobile" />
                            {itemComponent}
                        </div>
                    ) : (
                        itemComponent
                    );
                })
            ) : (
                <Feedback isLoading={isLoading} />
            )}
        </div>
    );
};

Collection.defaultProps = {
    className: "",
    redirections: {},
    restUrl: process.env.REST_URL
        ? process.env.REST_URL
        : localStorage.getItem("restUrl"),
    dfpMidAd: false
};

Collection.propTypes = {
    data: array.isRequired,
    itemComponent: func.isRequired,
    itemClassName: string,
    isLoading: bool,
    className: string,
    redirections: object,
    restUrl: string,
    trackImpressions: bool,
    trackClicks: bool,
    actionField: string,
    currentPage: number,
    showSeller: bool,
    dfpMidAd: bool,
    view: string
};

export default Collection;
